// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4087":"02a5cd84","9477":"d8e5927c","9722":"08856f3d"}[chunkId] + ".chunk.css";
};